<template>
    <b-modal
        :id="id"
        :title="title"
        centered
        no-close-on-backdrop
        @hidden="close"
    >
        <div class="row">
            <div class="form-group col-6">
                <label for="registrationStartsAt">Starts at</label>

                <input
                    id="registrationStartsAt"
                    v-model="registrationStartsAt"
                    type="date"
                    class="form-control"
                    :class="{ 'is-invalid': hasError('registrationStartsAt') }"
                />

                <div class="invalid-feedback">
                    {{ getError('registrationStartsAt') }}
                </div>
            </div>

            <div class="form-group col-6">
                <label for="registrationEndsAt">Ends at</label>

                <input
                    id="registrationEndsAt"
                    v-model="registrationEndsAt"
                    type="date"
                    class="form-control"
                    :class="{ 'is-invalid': hasError('registrationEndsAt') }"
                />

                <div class="invalid-feedback">
                    {{ getError('registrationEndsAt') }}
                </div>
            </div>
        </div>

        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>

                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="changeRange"
                >
                    Change
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'change-registration-range-modal'
        },
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            registrationStartsAt: null,
            registrationEndsAt: null,
            serverErrors: [],
            title: 'Change registration dates range'
        };
    },

    validations: {
        registrationStartsAt: {
            required
        },
        registrationEndsAt: {
            required,
            notBeforeStartDate(v, { registrationStartsAt }) {
                return this.$dayjs(v).isAfter(registrationStartsAt);
            }
        }
    },

    created() {
        this.setDates();
    },

    methods: {
        ...mapActions({
            getRegistrationDatesRange: 'courses/getRegistrationDatesRange',
            changeRegistrationDatesRange: 'courses/changeRegistrationDatesRange'
        }),

        async changeRange() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const data = {
                registrationStartsAt: this.registrationStartsAt,
                registrationEndsAt: this.registrationEndsAt
            };

            try {
                const { updatedAt } = await this.changeRegistrationDatesRange({
                    ...data,
                    id: this.value.id
                });

                this.$toaster('Registration dates range has been changed!');

                this.$emit('change', { ...data, updatedAt });

                this.$bvModal.hide(this.id);
            } catch (error) {
                const { response } = error;
                let errorMessage = 'Dates range could not be changed';

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        errorMessage = data;
                    }
                }

                console.error(error);

                this.$toasterError(errorMessage);
            }
        },

        close() {
            this.$bvModal.hide(this.id);
            this.setDates();
        },

        hasError(key) {
            return (
                this.$v[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v,
                this.serverErrors,
                key
            );
        },

        setDates() {
            const { registrationStartsAt, registrationEndsAt } = this.value;

            this.registrationStartsAt = registrationStartsAt;
            this.registrationEndsAt = registrationEndsAt;
        }
    }
};
</script>
